import http from "../http-common";

class UsuarioService {

    create(data) {
        return http.post("/usuario",data);
    }

    getByID(id) {
        return http.get(`/usuario/${id}`);
    }

    addPerfil(data) {
        return http.post("/usuario/addperfil", data);
    }

    getBySSID(ssid) {
        return http.get(`/usuario/ssid/${ssid}`);
    }
}

export default new UsuarioService();